import BaseDataObject from './BaseDataObject';
import Money from './Money';
import ResultOdds from './ResultOdds';

export default class ResultUpdate extends BaseDataObject {
  getTimestamp() {
    return this.getDate('timestamp');
  }

  hasResultType() {
    return this.has('type');
  }

  getResultType() {
    return this.getString('type');
  }

  getIsResultComplete() {
    return this.getBoolean('isResultComplete');
  }

  hasIsResultComplete() {
    return this.has('isResultComplete');
  }

  getTurnover() {
    return this.getObject('turnover', Money);
  }

  hasTurnover() {
    return this.has('turnover');
  }

  getNumberOfSystems() {
    return this.getInteger('nrOfSystems');
  }

  hasNumberOfSystems() {
    return this.has('nrOfSystems');
  }

  getNumberOfLegUpdates() {
    return this.getNumberOf('legResultUpdates');
  }

  getLegUpdate(index) {
    return this.getObject('legResultUpdates', ResultLegUpdate, index);
  }

  getNumberOfPayoutUpdates() {
    return this.getNumberOf('payOutUpdates');
  }

  getPayoutUpdate(index) {
    return this.getObject('payOutUpdates', PayoutUpdate, index);
  }

  hasOdds() {
    return this.has('oddsResults');
  }

  getOdds() {
    return this.getObjects('oddsResults', ResultOdds);
  }
}

class ResultLegUpdate extends BaseDataObject {
  getLegNumber() {
    return this.getInteger('legNr');
  }

  getLegIndex() {
    return this.getLegNumber() - 1;
  }

  getSystemsLeft() {
    return this.getInteger('systemsLeft');
  }

  hasSystemsLeft() {
    return this.has('systemsLeft');
  }

  getValue() {
    return this.getObject('value', Money);
  }

  hasValue() {
    return this.has('value');
  }

  getWinners() {
    return this.getIntegerArray('winners');
  }

  hasWinners() {
    return this.has('winners');
  }
}

class PayoutUpdate extends BaseDataObject {
  getNumberOfCorrects() {
    return this.getInteger('nrOfCorrects');
  }

  getPrizeGroup() {
    return this.getString('prizeGroup');
  }

  hasPrizeGroup() {
    return this.has('prizeGroup');
  }

  getNumberOfSystems() {
    return this.getInteger('nrOfSystems');
  }

  hasNumberOfSystems() {
    return this.has('nrOfSystems');
  }

  getPayoutAmount() {
    return this.getObject('payOutAmount', Money);
  }

  hasPayoutAmount() {
    return this.has('payOutAmount');
  }

  getTotalAmount() {
    return this.getObject('totalAmount', Money);
  }

  hasTotalAmount() {
    return this.has('totalAmount');
  }
}
